<section *ngIf="item.customField10=='Type 1'" class="sales-advantage-section">
    <div class="container">
        <div class="text-center">
            <h2 class="section-title" [style.font-size]="item.customField31"
                [ngStyle.lt-md]="{ 'font-size': item.customField32 }">{{ item.title }}</h2>
            <p class="section-subtitle"> <calsoft-editor-text [data]="data" [text]="item.customField20"
                    [style.font-size]="item.customField33" [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
                </calsoft-editor-text></p>
        </div>

        <div class="comparison-grid" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="32px">
            <div class="comparison-card without-crm" fxFlex="1 1 50%">
                <h3 class="card-title" [style.font-size]="item.customField37"
                    [ngStyle.lt-md]="{ 'font-size': item.customField38 }">{{item.customField35}}</h3>
                <ul class="feature-list">
                    <li class="feature-item" *ngFor="let img of leftArray">
                        <span class="icon red">&times;</span>
                        <span><calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>
                </ul>
            </div>

            <div class="comparison-card with-crm" fxFlex="1 1 50%">
                <h3 class="card-title" [style.font-size]="item.customField37"
                    [ngStyle.lt-md]="{ 'font-size': item.customField38 }">{{item.customField35}}</h3>
                <ul class="feature-list">
                    <li class="feature-item" *ngFor="let img of rightArray">
                        <span class="icon green">&#10004;</span>
                        <span><calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>



<section *ngIf="item.customField10=='Type 2'" class="sales-advantage-section">
    <div class="container">
        <div class="text-center">
            <h2 class="section-title" [style.font-size]="item.customField31"
                [ngStyle.lt-md]="{ 'font-size': item.customField32 }">{{ item.title }}</h2>
            <p class="section-subtitle"> <calsoft-editor-text [data]="data" [text]="item.customField20"
                    [style.font-size]="item.customField33" [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
                </calsoft-editor-text></p>
        </div>



        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" class="pricing-wrapper"
            fxLayoutGap="30px">
            <!-- Premium Card -->
            <div fxLayout="column" fxLayoutAlign="start  start" class="pricing-card premium-card">
                <h2 [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }">
                    {{item.customField35}}</h2>
                <h1>{{item.customField18}}</h1>
                <ul fxLayout="column" fxLayoutAlign="start  start">
                    <li *ngFor="let img of leftArray">
                        <span class="check">✔</span><span>
                            <calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>
                </ul>
    <a mat-raised-button [href]="item.customField16" class="action-button" target="_blank" rel="noopener">
                    {{ item.customField14 }}
                </a>
            </div>

            <!-- Custom Card -->
            <div fxLayout="column" fxLayoutAlign="start  start" class="pricing-card custom-card">
                <h2 [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }">
                    {{item.customField35}}</h2>
                <h1>{{item.customField19}}</h1>
                <ul fxLayout="column" fxLayoutAlign="start  start">
                    <li *ngFor="let img of rightArray">
                        <span class="icon green">✨</span>
                        <span><calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>

                </ul>
                <a mat-raised-button [href]="item.customField17" class="action-button" target="_blank" rel="noopener">
                    {{ item.customField15 }}
                </a>
            </div>

        </div>
    </div>  
</section>

